import "./App.css";
import AppWrapper from "./routes/Index";
// import Index from "./routes/Index";
// import { Provider } from "react-redux";

// import { store } from "./store/store";

function App() {
  return (
    <AppWrapper />
    // <Provider store={store}>
    //   <Index />
    // </Provider>
  );
}

export default App;
